// The follow-up days editor (spec C14 Defaults; design/kit SettingsEditor; Yehuda, Oct 29): how
// many days before the renewal date the VA calls the carrier when the renewal is not on its site
// (PR 211). The Manager and the Admin open it.
import { useState } from 'react';
import type { Api } from '../auth/api';
import { followUpCopy as c, followUpDaysOf, followUpSaveError } from './follow-up-lines';
import { ErrorLine, SettingsEditor } from './SettingsEditor';

type Props = {
  api: Api;
  days: number;
  onClose: () => void;
  onSaved: (toast: string) => void;
};

export function FollowUpEditor({ api, days, onClose, onSaved }: Props) {
  const [orig] = useState(() => String(days));
  const [d, setD] = useState(orig);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dirty = d !== orig;
  const next = followUpDaysOf(d);
  const bad = dirty && next === null;

  async function save() {
    if (next === null) return;
    setBusy(true);
    setError(null);
    const res = await api.saveFollowUpDays(next);
    setBusy(false);
    if (res.ok) onSaved(c.saved);
    else setError(followUpSaveError(res.error));
  }

  return (
    <SettingsEditor
      id="fu"
      title={c.title}
      sub={c.sub}
      dirty={dirty}
      valid={next !== null}
      busy={busy}
      error={error}
      onSave={() => void save()}
      onClose={onClose}
    >
      <div>
        <label className="flab" htmlFor="fu-days">
          {c.days}
        </label>
        <div className="col g6">
          <input
            id="fu-days"
            className="input mono"
            inputMode="numeric"
            autoComplete="off"
            value={d}
            aria-invalid={bad || undefined}
            aria-describedby={bad ? 'fu-days-err' : 'fu-days-hint'}
            onChange={(e) => setD(e.target.value)}
          />
          {bad ? (
            <ErrorLine id="fu-days-err" text={c.daysError} />
          ) : (
            <p id="fu-days-hint" className="fnote m0">
              {c.daysHint}
            </p>
          )}
        </div>
      </div>
    </SettingsEditor>
  );
}
